export const NAV_MENU = 'MENU'
export const NAV_MENU_ITEM = 'ITEM_MENU'
